import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import BlogDetails from '../Component/Blog/BlogDetails'
import BlogComment from '../Component/Blog/BlogComment'
import axios from 'axios'
import { domain, hrport, port } from '../App'
import { Helmet } from 'react-helmet'
import HomeNavBar from '../Component/HomeComponent/HomeNavBar'
import RightSideBlog from '../Component/RightSideBlog'
import { HrStorage } from '../Context/HrStore'


const ParticularBlog = () => {
    let { slug } = useParams()
    let { setactive } = useContext(HrStorage)
    let [blog, setBlog] = useState()
    useEffect(() => {
        setactive('blog')
        window.scrollTo(0, 0)
        if (slug) {
            axios.get(`${port}/api/blog/${slug}/`).then((response) => {
                const item = response.data;
                console.log(item);
                setBlog({
                    ...item,
                    img: item.content_image || item.card_image,
                    Main_Title: item.title,
                    Paragraph1: item.content,
                })
            }).catch((error) => {
                console.log(error);
            })
        }
    }, [slug])
    return (
        <>
            <HomeNavBar />
            <div className='container mx-auto col-xl-10 px-4 md:px-6'>
                {blog && <> <Helmet>
                    <title> {blog.Main_Title} </title>
                    <meta name="description" content="We are inviting you to know more about SkillLearningAcademy's journey to the success and innovation in training, upskilling and get mentoring support and guidance. " />
                    <link rel="canonical" href={`${domain}/blogs/${slug}`} />
                    <script type="application/ld+json">
                        {JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "BlogPosting",
                            "headline": blog.Main_Title,
                            "image": blog.img || "https://www.meridahr.com/MeridaConsultancyLogo.png",
                            "author": {
                                "@type": "Organization",
                                "name": "Merida HR Consulting"
                            },
                            "publisher": {
                                "@type": "Organization",
                                "name": "Merida HR Consulting",
                                "logo": {
                                    "@type": "ImageObject",
                                    "url": "https://www.meridahr.com/MeridaConsultancyLogo.png"
                                }
                            },
                            "datePublished": blog.created_at || "2026-06-17",
                            "description": blog.Paragraph1 ? blog.Paragraph1.slice(0, 150) : ""
                        })}
                    </script>
                    <script type="application/ld+json">
                        {JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "BreadcrumbList",
                            "itemListElement": [
                                {
                                    "@type": "ListItem",
                                    "position": 1,
                                    "name": "Home",
                                    "item": "https://www.meridahr.com/"
                                },
                                {
                                    "@type": "ListItem",
                                    "position": 2,
                                    "name": "Blog",
                                    "item": "https://www.meridahr.com/blogs"
                                },
                                {
                                    "@type": "ListItem",
                                    "position": 3,
                                    "name": blog.Main_Title,
                                    "item": `https://www.meridahr.com/blogs/${slug}`
                                }
                            ]
                        })}
                    </script>
                </Helmet>
                    <h1 className='d-none'>best training company</h1>
                    <h2 className='d-none'>top training institute </h2>
                </>}
                <section className='row my-5'>
                    <div className='col-lg-8 col-xl-9 '>
                        {blog && <BlogDetails data={blog} />}
                        {blog && <BlogComment id={blog.id} />}
                    </div>
                    <div className='col-lg-4 col-xl-3 '>
                        <RightSideBlog />
                    </div>
                </section>
            </div>
        </>
    )
}

export default ParticularBlog